import React, { useEffect } from "react"
import { Link } from "react-router-dom"

import { listenToTdMouseover } from "../../utils/table-animation.js"
import "../Table.sass"

const IncidentsTable = ({ data, error }) => {
  useEffect(() => {
    listenToTdMouseover()
  }, [data])
  return (
    <>
      <table>
        <thead>
          <tr>
            <th>Ocorrência</th>
            <th>Situação</th>
            <th>Criado em</th>
            <th>Solicitado por</th>
            {/* <th>Criado por</th> */}
            <th>Contrato</th>
            <th>Severidade</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data
              .filter((item) => item.statusnewid < 3)
              .map((item) => (
                <tr key={item.id}>
                  <td>
                    <Link to={"/incident/" + item["incidentid"]}>
                      <div>{item.title}</div>
                    </Link>
                  </td>
                  <td>{item["statusnewname"]}</td>
                  <td>
                    {
                      item[
                        "createdon@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </td>
                  <td>
                    {
                      item[
                        "_c2g_contact_value@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </td>
                  {/* <td>
                  {
                    item[
                      "_createdby_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </td> */}
                  <td>
                    {
                      item[
                        "_c2g_contrato_value@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </td>
                  <td>
                    {
                      item[
                        "c2g_severidade@OData.Community.Display.V1.FormattedValue"
                      ]
                    }
                  </td>
                </tr>
              ))
          ) : error == null ? (
            <tr>
              <td>Carregando...</td>
              <td></td>
              <td></td>
              <td></td>
              {/* <td></td> */}
              <td></td>
              <td></td>
            </tr>
          ) : error == "No incidents" ? (
            <tr>
              <td>Não há ocorrências cadastradas</td>
              <td></td>
              <td></td>
              <td></td>
              {/* <td></td> */}
              <td></td>
              <td></td>
            </tr>
          ) : (
            <tr>
              <td>Erro ao carregar as ocorrências</td>
              <td></td>
              <td></td>
              <td></td>
              {/* <td></td> */}
              <td></td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}

export default IncidentsTable
